import { List } from 'immutable';
import type { Action, Reducer } from 'redux';
import type { ErrorType } from '~/data/ErrorRecord';
import ErrorRecord from '~/data/ErrorRecord';
import type { UserRoleFields } from '~/components/containers/UserManagementContainer/data/UserRole';
import UserRolesRecord from './data/UserRolesRecord';
import * as actions from './actions';

// Saga action types are built at runtime, so cannot discriminate.
interface UserRolesAction extends Action<string> {
  response?: UserRoleFields[];
  error?: ErrorType;
}

function getInitialState() {
  return new UserRolesRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<UserRolesRecord, UserRolesAction> = (state = defaultState, action) => {
  switch (action.type) {
    case actions.getAvailableRoles.request:
      return state.merge({
        isLoading: true,
        error: undefined,
      });

    case actions.getAvailableRoles.success:
      return state.merge({
        isLoading: false,
        availableRoles: List(action.response),
      });

    case actions.getAvailableRoles.failure:
      return state.merge({
        isLoading: false,
        error: new ErrorRecord(action.error),
      });

    default:
      return state;
  }
};

export default reducer;
